var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-card",
    { staticClass: "order-log-filters" },
    [
      _c(
        "el-form",
        {
          attrs: { model: _vm.form, "label-position": "top" },
          nativeOn: {
            submit: function ($event) {
              $event.preventDefault()
              return _vm.submit($event)
            },
          },
        },
        [
          _c(
            "el-row",
            { attrs: { gutter: 20 } },
            [
              _c(
                "el-col",
                { attrs: { lg: 6, md: 12, sm: 12 } },
                [
                  _c(
                    "el-form-item",
                    [
                      _c(
                        "template",
                        { slot: "label" },
                        [
                          _c(
                            "el-select",
                            {
                              staticStyle: { width: "100%" },
                              attrs: {
                                "aria-label": _vm.$t(
                                  "orderLogAddress.numberType"
                                ),
                              },
                              model: {
                                value: _vm.form.numberType,
                                callback: function ($$v) {
                                  _vm.$set(_vm.form, "numberType", $$v)
                                },
                                expression: "form.numberType",
                              },
                            },
                            [
                              _c("el-option", {
                                attrs: {
                                  label:
                                    _vm.$t("newOrder.waybillNumber") +
                                    "/" +
                                    _vm.$t("GlobalSetObj.serviceLogistics"),
                                  value: _vm.numberTypes.WAYBILL,
                                },
                              }),
                              _c("el-option", {
                                attrs: {
                                  label: _vm.$t(
                                    "orderCenterCont.TheOrderNumberCustomer"
                                  ),
                                  value: _vm.numberTypes.ORDER,
                                },
                              }),
                              _c("el-option", {
                                attrs: {
                                  label: _vm.$t("placeOrder.customerNumber"),
                                  value: _vm.numberTypes.CUSTOMER,
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "div",
                        { staticClass: "number-search" },
                        [
                          _c("el-input", {
                            attrs: {
                              placeholder: _vm.$t("orderDetails.pleaseInput"),
                              clearable: "",
                            },
                            nativeOn: {
                              keyup: function ($event) {
                                if (
                                  !$event.type.indexOf("key") &&
                                  _vm._k(
                                    $event.keyCode,
                                    "enter",
                                    13,
                                    $event.key,
                                    "Enter"
                                  )
                                ) {
                                  return null
                                }
                                return _vm.singleSearch($event)
                              },
                            },
                            model: {
                              value: _vm.form.number,
                              callback: function ($$v) {
                                _vm.$set(
                                  _vm.form,
                                  "number",
                                  typeof $$v === "string" ? $$v.trim() : $$v
                                )
                              },
                              expression: "form.number",
                            },
                          }),
                          _c("el-button", {
                            attrs: {
                              icon: "el-icon-search",
                              "aria-label": _vm.$t("operationCenter.Procurar"),
                            },
                            on: { click: _vm.singleSearch },
                          }),
                          _c(
                            "el-popover",
                            {
                              attrs: {
                                placement: "bottom-end",
                                trigger: "manual",
                                width: "330",
                              },
                              model: {
                                value: _vm.showNumbers,
                                callback: function ($$v) {
                                  _vm.showNumbers = $$v
                                },
                                expression: "showNumbers",
                              },
                            },
                            [
                              _c("el-input", {
                                attrs: {
                                  type: "textarea",
                                  rows: 10,
                                  placeholder: _vm.$t("newOrder.PreciseSearch"),
                                },
                                model: {
                                  value: _vm.batchText,
                                  callback: function ($$v) {
                                    _vm.batchText = $$v
                                  },
                                  expression: "batchText",
                                },
                              }),
                              _c(
                                "div",
                                { staticClass: "batch-actions" },
                                [
                                  _c(
                                    "el-button",
                                    {
                                      attrs: { size: "small" },
                                      on: { click: _vm.clearNumbers },
                                    },
                                    [_vm._v(_vm._s(_vm.$t("newOrder.empty")))]
                                  ),
                                  _c(
                                    "el-button",
                                    {
                                      attrs: { size: "small" },
                                      on: {
                                        click: function ($event) {
                                          _vm.showNumbers = false
                                        },
                                      },
                                    },
                                    [
                                      _vm._v(
                                        _vm._s(_vm.$t("orderExport.close"))
                                      ),
                                    ]
                                  ),
                                  _c(
                                    "el-button",
                                    {
                                      attrs: { size: "small", type: "primary" },
                                      on: { click: _vm.batchSearch },
                                    },
                                    [_vm._v(_vm._s(_vm.$t("newOrder.search")))]
                                  ),
                                ],
                                1
                              ),
                              _c("el-button", {
                                attrs: {
                                  slot: "reference",
                                  icon: "el-icon-document",
                                  "aria-label": _vm.$t(
                                    "newOrder.PreciseSearch"
                                  ),
                                },
                                on: {
                                  click: function ($event) {
                                    _vm.showNumbers = !_vm.showNumbers
                                  },
                                },
                                slot: "reference",
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    2
                  ),
                ],
                1
              ),
              _c(
                "el-col",
                { attrs: { lg: 8, md: 12, sm: 12 } },
                [
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label:
                          _vm.$t("GlobalSetObj.CreationTime") +
                          " (" +
                          _vm.$t("orderLogAddress.brazilTime") +
                          ")",
                      },
                    },
                    [
                      _c("el-date-picker", {
                        staticStyle: { width: "100%" },
                        attrs: {
                          type: "datetimerange",
                          "value-format": "yyyy-MM-dd HH:mm:ss",
                          "default-time": ["00:00:00", "23:59:59"],
                          "range-separator": _vm.$t("operationCenter.to"),
                          "start-placeholder": _vm.$t(
                            "operationCenter.startDate"
                          ),
                          "end-placeholder": _vm.$t("operationCenter.endDate"),
                        },
                        model: {
                          value: _vm.form.dates,
                          callback: function ($$v) {
                            _vm.$set(_vm.form, "dates", $$v)
                          },
                          expression: "form.dates",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-col",
                { attrs: { lg: 6, md: 12, sm: 12 } },
                [
                  _c(
                    "el-form-item",
                    { attrs: { label: _vm.$t("receivablePayable.customer") } },
                    [
                      _c(
                        "el-select",
                        {
                          staticStyle: { width: "100%" },
                          attrs: {
                            placeholder: _vm.$t(
                              "spareNumberPoo.Only10AreDisplayed"
                            ),
                            "remote-method": _vm.getCustomers,
                            clearable: "",
                            filterable: "",
                            remote: "",
                            "reserve-keyword": "",
                          },
                          on: {
                            focus: function ($event) {
                              return _vm.getCustomers()
                            },
                          },
                          model: {
                            value: _vm.form.customerId,
                            callback: function ($$v) {
                              _vm.$set(_vm.form, "customerId", $$v)
                            },
                            expression: "form.customerId",
                          },
                        },
                        _vm._l(_vm.customers, function (customer) {
                          return _c("el-option", {
                            key: customer.id,
                            attrs: {
                              label:
                                customer.customerAlias +
                                "(" +
                                customer.username +
                                ")",
                              value: customer.id,
                            },
                          })
                        }),
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-col",
                { attrs: { lg: 4, md: 12, sm: 12 } },
                [
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: _vm.$t("orderCenterCont.WhetherSuccessful"),
                      },
                    },
                    [
                      _c(
                        "el-select",
                        {
                          staticStyle: { width: "100%" },
                          model: {
                            value: _vm.form.state,
                            callback: function ($$v) {
                              _vm.$set(_vm.form, "state", $$v)
                            },
                            expression: "form.state",
                          },
                        },
                        [
                          _c("el-option", {
                            attrs: {
                              label: _vm.$t("GlobalSetObj.all"),
                              value: null,
                            },
                          }),
                          _c("el-option", {
                            attrs: {
                              label: _vm.$t("GlobalSetObj.yes"),
                              value: _vm.states.SUCCESS,
                            },
                          }),
                          _c("el-option", {
                            attrs: {
                              label: _vm.$t("GlobalSetObj.No"),
                              value: _vm.states.FAILURE,
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-col",
                { attrs: { lg: 6, md: 12, sm: 12 } },
                [
                  _c(
                    "el-form-item",
                    { attrs: { label: _vm.$t("orderLogAddress.result") } },
                    [
                      _c(
                        "el-select",
                        {
                          staticStyle: { width: "100%" },
                          model: {
                            value: _vm.form.receiveAddressCheckResult,
                            callback: function ($$v) {
                              _vm.$set(
                                _vm.form,
                                "receiveAddressCheckResult",
                                $$v
                              )
                            },
                            expression: "form.receiveAddressCheckResult",
                          },
                        },
                        [
                          _c("el-option", {
                            attrs: {
                              label: _vm.$t("GlobalSetObj.all"),
                              value: null,
                            },
                          }),
                          _vm._l(_vm.results, function (value) {
                            return _c("el-option", {
                              key: value,
                              attrs: {
                                value: value,
                                label: _vm.$t("orderLogAddress." + value),
                              },
                            })
                          }),
                        ],
                        2
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _vm.batchNumbers.length
            ? _c(
                "div",
                { staticClass: "batch-summary" },
                [
                  _c("el-tooltip", { attrs: { placement: "bottom" } }, [
                    _c("pre", { attrs: { slot: "content" }, slot: "content" }, [
                      _vm._v(_vm._s(_vm.batchText)),
                    ]),
                    _c("span", [_vm._v(_vm._s(_vm.batchNumbers.join("，")))]),
                  ]),
                  _c("el-button", {
                    attrs: {
                      type: "text",
                      icon: "el-icon-close",
                      "aria-label": _vm.$t("newOrder.empty"),
                    },
                    on: { click: _vm.clearNumbers },
                  }),
                ],
                1
              )
            : _vm._e(),
          _c(
            "el-button",
            {
              attrs: { icon: "el-icon-search", size: "small", type: "primary" },
              on: { click: _vm.submit },
            },
            [_vm._v(_vm._s(_vm.$t("operationCenter.Procurar")))]
          ),
          _c(
            "el-button",
            {
              attrs: { icon: "el-icon-refresh-left", size: "small" },
              on: { click: _vm.reset },
            },
            [_vm._v(_vm._s(_vm.$t("operationCenter.reset")))]
          ),
          _c(
            "el-button",
            {
              attrs: { size: "small", disabled: _vm.exportDisabled },
              on: {
                click: function ($event) {
                  return _vm.$emit("export")
                },
              },
            },
            [_vm._v(_vm._s(_vm.$t("operationCenter.exports")))]
          ),
          _c("p", { staticClass: "query-hint" }, [
            _c("i", { staticClass: "el-icon-info" }),
            _vm._v(" " + _vm._s(_vm.$t("orderLogAddress.hint"))),
          ]),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }